import { ContextData } from "@reporting/rp-types/analytics";
import { CustomParams } from "../types";

export function extractContextParameters(contextData: Partial<ContextData>): CustomParams {
	const params: CustomParams = {};

	params['filters'] = contextData?.filters || [];

	for (const param in contextData?.parameters || {}) {
		params[param] = contextData.parameters[param];
	}

	// contextData?.filters.forEach(filter => {
	// 	const items: string[][] = [];
	// 	if (typeof filter.items === 'string') {
	// 		items.push([filter.items]);
	// 	} else if (Array.isArray(filter.items)) {
	// 		filter.items.forEach(item => {
	// 			if (typeof item === 'string') {
	// 				items.push([item]);
	// 			} else if (Array.isArray(item)) {
	// 				items.push(item.map(i => String(i)));
	// 			}
	// 		});
	// 	}

	// 	if (/\d+/.test(filter.dim)) {
	// 		params[`dim${filter.dim}`] = items;
	// 	} else if (/^P/i.test(filter.dim)) {
	// 		params['period'] = items;
	// 	}
	// });

	return params;
}

export function extractQueryParameters(queryParameters: string|Record<string, any>): CustomParams {
	let parameters: CustomParams = {};
	if (typeof queryParameters === 'string') {
		try {
			parameters = JSON.parse(decodeURIComponent(queryParameters));
		} catch {
			parameters = {};
		}
	} else {
		parameters = queryParameters;
	}

	for (const key of Object.keys(parameters)) {
		const value = parameters[key];
		if (typeof value === 'string') {
			const decoded = decodeURIComponent(value);
			if (decoded.startsWith('[') || decoded.startsWith('{')) {
				try {
					parameters[key] = JSON.parse(decoded);
				} catch {
					parameters[key] = decoded;
				}
			}
		}
	}

	return parameters;
}
